import React from 'react'

import GroupsFilter from '../../../../containers/groups/filters/GroupsFilter'
import ProfilesFilter from '../../../../containers/profiles/filters/ProfilesFilter'
import SideModalFiltersWrapper from '../../../../components/filter/SideModalFiltersWrapper'
import ActivatedFilter from '../../../../components/filter/ActivatedFilter'

const FilterModal = ({ open, onClose }) => {
  return (
    <SideModalFiltersWrapper open={open} onClose={onClose}>
      <ProfilesFilter presentation="list" />
      <GroupsFilter presentation="list" />
      <ActivatedFilter presentation="list" />
    </SideModalFiltersWrapper>
  )
}

export default FilterModal
